import { Box, Button, Typography } from '@mui/material';
import { createColumnHelper } from '@tanstack/react-table';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import * as XLSX from 'xlsx';
import eOpsLogo from '../../images/eops.png';
import excel from '../../images/excel.png';
import mepcoLogo from '../../images/mepcoLogo.png';
import pdf from '../../images/pdf.png';
import print from '../../images/print.png';
import { cfpBaseUrl } from '../../network/urls';
import { convertDate, convertDatewithTime, numberFormatting, getName } from '../../services/Functions';
import { internalIconStyles } from '../../style/common';
import '../../style/common.scss';
import CircularProgress from "@mui/material/CircularProgress";
import FESCOLOGO from "../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from '../../images/pitc.png';

const BatchWiseAssessmentReport = () => {
    const columnHelper = createColumnHelper();
    const tableRef = useRef(null);
    const [assmntBatchWise, setAssmntBatchWise] = useState([]);
    // const { officeCode: offCode } = useSelector(state => state.officeCode)
    const { token, code, name, roleName, roleTypeName, cscID, cfcLevelId } = useSelector(state => state.auth)
    const companyCode = code.slice(0, 2)
    const offCode = code
    const [apiData, setApiData] = useState([]);
    const [circleCode, setCircleCode] = useState('');
    const [circleName, setCircleName] = useState('');
    const [officeCode, setOfficeCode] = useState();
    const [officeName, setOfficeName] = useState('');
    const [selectedDivision, setSelectedDivision] = useState('');
    const [selectedSubDivision, setSelectedSubDivision] = useState('');
    const [filteredDivisions, setFilteredDivisions] = useState([]);
    const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
    const [hierarchy, setHierarchy] = useState('');
    const [filteredCircles, setFilteredCircles] = useState([]);
    const [isGoDisabled, setIsGoDisabled] = useState(false); 
  const [lastAppliedFilters, setLastAppliedFilters] = useState(null);
    const [data, setData] = useState([]);
     const [selectedCompanyCode, setSelectedCompanyCode] = useState('');
    const [loading, setLoading] = useState(false); // State to track loading
    const [error, setError] = useState(null);
     const [subDivisions, setSubDivisions] = useState(JSON.parse(window.localStorage.getItem('subDivisions')) || []);

    const formatNumber = (value) => {
        if (value === undefined || value === null || value === "") {
            return "-";
        }
        const num = parseFloat(value);
        return isNaN(num) ? "-" : num.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    const formatNumberWithoutFraction = (value) => {
        if (value === undefined || value === null || value === "") {
            return "-";
        }
        const num = parseFloat(value);
        return isNaN(num) ? "-" : num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    const fetchData = async (officeCode) => {
        try {
            setLoading(true);
            const url = `https://ibs-dashboard-data-api.pitc.com.pk/api/v1/common?apiName=eops_assmnt_todate&P_SDIV=${officeCode}`;
            const response = await fetch(url, {
                method: "GET",
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            } 

            const result = await response.json();

            if (result?.rows) {
                const data = result.rows
                if (data) {
                    setLoading(false);
                    setData(result.rows);
                }
            } else {
                setData([]); // No rows
            }
        } catch (err) {
            console.error("Error fetching data:", err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };
    const getLogo = (code) => {
        switch (code) {
            case '10':
                return pitcLogo
            case '11':
                return LESCOLOGO
            case '12':
                return GEPCOLOGO
            case '13':
                return FESCOLOGO
            case '14':
                return IESCOLOGO
            case '15':
                return MEPCOLOGO
            case '26':
                return PESCOLOGO
            case '27':
                return HAZECOLOGO
            case '37':
                return HESCOLOGO
            case '38':
                return SEPCOLOGO
            case '48':
                return QESCOLOGO
            case '59':
                return TESCOLOGO
            default:
                return MEPCOLOGO
        }
    }
    const getCompanies = (code) => {
        switch (code) {
            case '10':
                return "Power Information Technology Company"
            case '11':
                return "Lahore Electric Supply Company"
            case '12':
                return "Gujranwala Electric Power Company"
            case '13':
                return "Faisalabad Electric Supply Company"
            case '14':
                return "Islamabad Electric Supply Company"
            case '15':
                return "Multan Electric Power Company"
            case '26':
                return "Peshawar Electric Supply Company"
            case '27':
                return "Hazara Electric Supply Company"
            case '38':
                return "Sukkur Electric Power Company"
            case '37':
                return "Hyderabad Electric Supply Company"
            case '48':
                return "Quetta Electric Supply Company"
            case '59':
                return "Tribal Electric Supply Company"

        }
    }
    const DownloadPdf = async (print) => {
        return new Promise((resolve, reject) => {
            let offName = officeName;
            let dateToPrint = getCurrentDateFormatted(new Date);

            // Define header structure
            const headers = [
                [
                    { content: 'Batch', rowSpan: 2, valign: 'center', styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255], fontStyle: 'bold' } },
                    { content: 'Opening Balance (Mil)', rowSpan: 2, valign: 'center', styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255], fontStyle: 'bold' } },
                    { content: 'Assessment (Rs. in Mil)', colSpan: 6, valign: 'middle', styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255], fontStyle: 'bold' } },
                    { content: 'Adjustments', colSpan: 2, valign: 'middle', styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255], fontStyle: 'bold' } },
                    { content: 'Detection', colSpan: 2, valign: 'middle', styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255], fontStyle: 'bold' } },
                    { content: 'Import', colSpan: 2, valign: 'middle', styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255], fontStyle: 'bold' } },
                    { content: 'Export', colSpan: 2, valign: 'middle', styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255], fontStyle: 'bold' } },
                    { content: 'Net Meter Count', rowSpan: 2, valign: 'center', styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255], fontStyle: 'bold' } },
                    { content: 'Units Billed', rowSpan: 2, valign: 'center', styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255], fontStyle: 'bold' } },

                ],
                [
                    { content: 'Govt.', styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] } },
                    { content: 'Private', styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] } },
                    { content: 'Current', styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] } },
                    { content: 'Adjustment', styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] } },
                    { content: 'Detection', styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] } },
                    { content: 'Net Amount', styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] } },
                    { content: 'No.', styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] } },
                    { content: 'Units (kWh)', styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] } },
                    { content: 'No.', styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] } },
                    { content: 'Units (kWh)', styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] } },
                    { content: 'Peak', styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] } },
                    { content: 'Off-Peak', styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] } },
                    { content: 'Peak', styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] } },
                    { content: 'Off-Peak', styles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] } },

                ]
            ];


            const totals = {
                BATCH: 0,
                OP_BAL: 0,
                ASSESSMENT_G: 0,
                ASSESSMENT: 0,
                ADJ_AMOUNT: 0,
                DET_AMOUNT: 0,
                NET: 0,
                NO_ADJ: 0,
                ADJ_UNITS: 0,
                NO_DET: 0,
                DET_UNITS: 0,
                KWH_PRV_REM_OFPK: 0,
                KWH_PRV_REM_PK: 0,
                KWH_REM_OFPK: 0,
                KWH_REM_PK: 0,
                NETMTR_CNT: 0,
                UNITS: 0,
            };

            // Define data rows
            const body = data.map((item) => {
                totals.BATCH += parseFloat(item.BATCH) || 0;
                totals.OP_BAL += parseFloat(item.OP_BAL) || 0;
                totals.ASSESSMENT_G += parseFloat(item.ASSESSMENT_G) || 0;
                totals.ASSESSMENT += parseFloat(item.ASSESSMENT) || 0;
                totals.ADJ_AMOUNT += parseFloat(item.ADJ_AMOUNT) || 0;
                totals.DET_AMOUNT += parseFloat(item.DET_AMOUNT) || 0;
                totals.NET += parseFloat(item.NET) || 0;
                totals.NO_ADJ += parseFloat(item.NO_ADJ) || 0;
                totals.ADJ_UNITS += parseFloat(item.ADJ_UNITS) || 0;
                totals.NO_DET += parseFloat(item.NO_DET) || 0;
                totals.DET_UNITS += parseFloat(item.DET_UNITS) || 0;
                totals.KWH_PRV_REM_OFPK += parseFloat(item.KWH_PRV_REM_OFPK) || 0;
                totals.KWH_PRV_REM_PK += parseFloat(item.KWH_PRV_REM_PK) || 0;
                totals.KWH_REM_OFPK += parseFloat(item.KWH_REM_OFPK) || 0;
                totals.KWH_REM_PK += parseFloat(item.KWH_REM_PK) || 0;
                totals.NETMTR_CNT += parseFloat(item.NETMTR_CNT) || 0;
                totals.UNITS += parseFloat(item.UNITS) || 0;

                return [
                    item.BATCH || '-',
                    formatToMillions(item.OP_BAL) || '-',
                    formatToMillions(item.ASSESSMENT_G) || '-',
                    formatToMillions(item.ASSESSMENT - item.ASSESSMENT_G) || '-',
                    formatToMillions(item.ASSESSMENT) || '-',
                    formatToMillions(item.ADJ_AMOUNT) || '-',
                    formatToMillions(item.DET_AMOUNT) || '-',
                    formatToMillions(item.NET) || '-',
                    formatNumberWithoutFraction(item.NO_ADJ) || '-',
                    formatNumberWithoutFraction(item.ADJ_UNITS) || '-',
                    formatNumberWithoutFraction(item.NO_DET) || '-',
                    formatNumberWithoutFraction(item.DET_UNITS) || '-',
                    formatNumberWithoutFraction(item.KWH_PRV_REM_OFPK) || '-',
                    formatNumberWithoutFraction(item.KWH_PRV_REM_PK) || '-',
                    formatNumberWithoutFraction(item.KWH_REM_OFPK) || '-',
                    formatNumberWithoutFraction(item.KWH_REM_PK) || '-',
                    formatNumberWithoutFraction(item.NETMTR_CNT) || '-',
                    formatNumberWithoutFraction(item.UNITS) || '-',
                ];
            });

            // Add the "Total" row at the end
            const totalRow = [
                { content: 'Total', styles: { fontStyle: 'bold' } }, // Set "Total" to bold
                formatToMillions(totals.OP_BAL),
                formatToMillions(totals.ASSESSMENT_G),
                formatToMillions(totals.ASSESSMENT - totals.ASSESSMENT_G),
                formatToMillions(totals.ASSESSMENT),
                formatToMillions(totals.ADJ_AMOUNT),
                formatToMillions(totals.DET_AMOUNT),
                formatToMillions(totals.NET),
                formatNumberWithoutFraction(totals.NO_ADJ),
                formatNumberWithoutFraction(totals.ADJ_UNITS),
                formatNumberWithoutFraction(totals.NO_DET),
                formatNumberWithoutFraction(totals.DET_UNITS),
                formatNumberWithoutFraction(totals.KWH_PRV_REM_OFPK),
                formatNumberWithoutFraction(totals.KWH_PRV_REM_PK),
                formatNumberWithoutFraction(totals.KWH_REM_OFPK),
                formatNumberWithoutFraction(totals.KWH_REM_PK),
                formatNumberWithoutFraction(totals.NETMTR_CNT),
                formatNumberWithoutFraction(totals.UNITS),
            ];

            body.push(totalRow); // Append the total row to the body

            // Initialize PDF and set basic layout
            const pdf = new jsPDF('landscape', 'mm', 'a4', { compressPdf: true });
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const logoWidth = companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' || companyCode === '27' ? 25 : 30;
            const logoHeight = companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' | companyCode === '27' ? 20 : 10;
            pdf.addImage(getLogo(companyCode), 'PNG', 15, 5, logoWidth, logoHeight);

            const eOpsLogoWidth = 20;
            const eOpsLogoHeight = 8;
            const eOpsLogoXPosition = companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' | companyCode === '27' ? 43 : 17;
            pdf.addImage(eOpsLogo, 'PNG', eOpsLogoXPosition, companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' | companyCode === '27' ? 12 : 17, eOpsLogoWidth, eOpsLogoHeight);


            pdf.setFontSize(10);
            pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
            pdf.text("Name: " + name, pageWidth - 65, 17);
            if (roleName === 'Customer Services Manager') {
                pdf.setFontSize(8); // Reduce font size if the role is 'Customer Services Manager'
            } else {
                pdf.setFontSize(10); // Use default font size for other roles
            }
            pdf.text("Designation: " + roleName, pageWidth - 65, 22);

            pdf.setFontSize(12);
            pdf.text(getCompanies(companyCode), pageWidth / 2, 12, { align: 'center' });
            pdf.text(`Batch-Wise Assessment Report`, pageWidth / 2, 18, { align: 'center' });
            pdf.setFontSize(10);
            pdf.text(`Daily Batch-Wise Assessment Report for ${offName} of ${dateToPrint}`, pageWidth / 2, 25, { align: 'center' });

            // Generate table in PDF
            pdf.autoTable({
                startY: 28,
                head: headers,
                body: body,
                styles: {
                    cellPadding: 1,
                    fontSize: 8,
                    halign: 'center',
                    lineWidth: 0.25,
                    lineColor: 'white'
                },
                margin: { top: 10, left: 15, right: 15 },
                didDrawCell: (data) => {
                    // Add vertical lines between specific columns
                    const columnsWithVerticalLine = [7]; // Indices of columns after which vertical lines should be drawn
                    const cell = data.cell;
                    const doc = data.doc;

                    if (columnsWithVerticalLine.includes(data.column.index)) {
                        const startX = cell.x + cell.width; // Right edge of the current cell
                        const startY = cell.y;
                        const endY = cell.y + cell.height;
                        doc.setDrawColor(0, 0, 0); // Set the color of the line (black)
                        doc.setLineWidth(0.5); // Set the thickness of the line
                        doc.line(startX, startY, startX, endY); // Draw vertical line
                    }
                }
            });

            const totalPages = pdf.internal.getNumberOfPages();
            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                const pageNumberText = `Page ${i} of ${totalPages}`;
                pdf.setFontSize(10);
                pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
            }

            // Save or download the PDF
            if (print) {
                pdf.save(`${offName}-${dateToPrint}-daily-batch-wise-assessment-report.pdf`);
            } else {
                resolve(pdf);
            }
        });
    };

    const exportToExcel = () => {
        let offName = officeName
        let dateToPrint = convertDate(new Date());
        const wb = XLSX.utils.table_to_book(tableRef.current, { sheet: 'Sheet1' });
        const ws = wb.Sheets['Sheet1'];
        const headingText = "New Connection Exceeded Application Summary";
        const range = XLSX.utils.decode_range(ws["!ref"]);
        const columnCount = range.e.c - range.s.c + 1;
        XLSX.utils.sheet_add_aoa(ws, [[headingText]], { origin: "A1" });
        ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: columnCount - 1 } }];
        if (!ws["A1"]) ws["A1"] = {};
        ws["A1"].s = { alignment: { horizontal: "center", vertical: "center" }, font: { bold: true } };
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        saveAs(new Blob([wbout]), `${offName}-${dateToPrint} -daily-batch-wise-assessment-report.xlsx`);
    };

    const printPDF = async () => {
        let pdf = await DownloadPdf(false);
        const pdfUrl = pdf.output('bloburl');

        // Create an iframe
        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.top = '0';
        iframe.style.left = '0';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.src = pdfUrl;
        document.body.appendChild(iframe);

        // Create a cancel button
        const cancelButton = document.createElement('button');
        cancelButton.textContent = 'Cancel';
        cancelButton.style.position = 'fixed';
        cancelButton.style.top = '20px';
        cancelButton.style.right = '20px';
        cancelButton.style.padding = '10px 20px';
        cancelButton.style.backgroundColor = '#ff4d4d';
        cancelButton.style.color = 'white';
        cancelButton.style.border = 'none';
        cancelButton.style.borderRadius = '5px';
        cancelButton.style.cursor = 'pointer';
        document.body.appendChild(cancelButton);

        // Print the PDF when the iframe loads
        iframe.onload = () => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
        };

        // Remove iframe and cancel button when cancel button is clicked
        cancelButton.addEventListener('click', () => {
            if (iframe.parentNode) {
                document.body.removeChild(iframe);
            }
            if (cancelButton.parentNode) {
                document.body.removeChild(cancelButton);
            }
        });
    };


    function getCurrentDateFormatted(date) {
        const day = String(date.getDate()).padStart(2, '0');
        const options = { month: 'short' };
        const month = date.toLocaleString('en-US', options);
        const year = String(date.getFullYear()).slice(-2);
        return `${day}-${month}-${year}`;
    }

  // Fetch subDivisions for code == 10
   useEffect(() => {
     if (code == 10 && selectedCompanyCode) {
       const fetchSubDivisions = async () => {
         setLoading(true);
         const myHeaders = new Headers();
         myHeaders.append('Authorization', token);
         const formdata = new FormData();
         formdata.append('companyCode', selectedCompanyCode);
         const requestOptions = {
           method: 'POST',
           headers: myHeaders,
           body: formdata,
           redirect: 'follow',
         };
         try {
           const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
           if (response.ok) {
             const result = await response.json();
             if (result.status === '200') {
               setSubDivisions(result.message);
               setApiData(result.message);
               // Populate circles
               const circles = result.message.reduce((acc, curr) => {
                 if (!acc.some(item => item.circleCode === curr.circleCode)) {
                   acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
                 }
                 return acc;
               }, []);
               setFilteredCircles(circles);
             } else {
               console.error('Error fetching subDivisions:', result.message);
               setSubDivisions([]);
               setFilteredCircles([]);
             }
           } else {
             throw new Error(`Request failed with status ${response.status}`);
           }
         } catch (error) {
           console.error('Error fetching subDivisions:', error);
           setSubDivisions([]);
           setFilteredCircles([]);
         } finally {
           setLoading(false);
         }
       };
       fetchSubDivisions();
     } else if (code != 10) {
       // For code != 10, populate circles from localStorage subDivisions
       const circles = subDivisions.reduce((acc, curr) => {
         if (!acc.some(item => item.circleCode === curr.circleCode)) {
           acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
         }
         return acc;
       }, []);
       setFilteredCircles(circles);
     }
   }, [code, selectedCompanyCode, token, cfpBaseUrl]);
 
   const handleChangeCompany = async (e) => {
     const selectedCompany = e.target.value;
     setSelectedCompanyCode(selectedCompany);
     setOfficeCode(selectedCompany);
     setOfficeName(getCompanies(selectedCompany) || '');
 
     if (code == 10 && selectedCompany) {
       setLoading(true);
       const myHeaders = new Headers();
       myHeaders.append('Authorization', token);
       const formdata = new FormData();
       formdata.append('companyCode', selectedCompany);
       const requestOptions = {
         method: 'POST',
         headers: myHeaders,
         body: formdata,
         redirect: 'follow',
       };
 
       try {
         const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
         if (response.ok) {
           const result = await response.json();
           if (result.status === '200') {
             setSubDivisions(result.message);
             setApiData(result.message);
 
             // Reset dropdowns
             setCircleCode('');
             setSelectedDivision('');
             setSelectedSubDivision('');
             setCircleName('');
             setFilteredDivisions([]);
             setFilteredSubDivisions([]);
 
             // Populate circles
             const circles = result.message.reduce((acc, curr) => {
               if (!acc.some(item => item.circleCode === curr.circleCode)) {
                 acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
               }
               return acc;
             }, []);
             setFilteredCircles(circles);
           } else {
             console.error('Error fetching subDivisions:', result.message);
             setSubDivisions([]);
             setFilteredCircles([]);
           }
         } else {
           throw new Error(`Request failed with status ${response.status}`);
         }
       } catch (error) {
         console.error('Error fetching subDivisions:', error);
         setSubDivisions([]);
         setFilteredCircles([]);
       } finally {
         setLoading(false);
       }
     } else if (!selectedCompany) {
       // Reset when no company is selected
       setOfficeName('PITC');
       setCircleCode('');
       setSelectedDivision('');
       setSelectedSubDivision('');
       setCircleName('');
       setFilteredDivisions([]);
       setFilteredSubDivisions([]);
       setFilteredCircles([]);
       setSubDivisions([]);
       setApiData([]);
     }
   };
 
   const handleCircleChange = async (event) => {
     const selectedCircleCode = event.target.value ? parseInt(event.target.value) : '';
     if (code == 10 && selectedCircleCode && selectedCompanyCode) {
       setLoading(true);
       const myHeaders = new Headers();
       myHeaders.append('Authorization', token);
       const formdata = new FormData();
       formdata.append('companyCode', selectedCompanyCode);
       formdata.append('circleCode', selectedCircleCode);
       const requestOptions = {
         method: 'POST',
         headers: myHeaders,
         body: formdata,
         redirect: 'follow',
       };
 
       try {
         const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
         if (response.ok) {
           const result = await response.json();
           if (result.status === '200') {
             setSubDivisions(result.message);
             setApiData(result.message);
 
             setCircleCode(selectedCircleCode);
             setOfficeCode(selectedCircleCode);
             const circle = filteredCircles.find(circle => circle.circleCode === selectedCircleCode);
             const circleName = circle?.circleName || '';
             setOfficeName(circleName.concat(' Circle'));
             setCircleName(circleName);
             setSelectedDivision('');
             setSelectedSubDivision('');
             setFilteredSubDivisions([]);
 
             // Populate divisions
             const uniqueDivisions = result.message
               .filter(item => item.circleCode === selectedCircleCode)
               .reduce((acc, item) => {
                 if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                   acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
                 }
                 return acc;
               }, []);
             setFilteredDivisions(uniqueDivisions);
           } else {
             console.error('Error fetching subDivisions:', result.message);
             setSubDivisions([]);
             setFilteredDivisions([]);
           }
         } else {
           throw new Error(`Request failed with status ${response.status}`);
         }
       } catch (error) {
         console.error('Error fetching subDivisions:', error);
         setSubDivisions([]);
         setFilteredDivisions([]);
       } finally {
         setLoading(false);
       }
     } else if (code == 10 && !selectedCircleCode && selectedCompanyCode) {
       // Handle "All Circle" selection for code == 10
       setLoading(true);
       const myHeaders = new Headers();
       myHeaders.append('Authorization', token);
       const formdata = new FormData();
       formdata.append('companyCode', selectedCompanyCode);
       const requestOptions = {
         method: 'POST',
         headers: myHeaders,
         body: formdata,
         redirect: 'follow',
       };
 
       try {
         const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
         if (response.ok) {
           const result = await response.json();
           if (result.status === '200') {
             setSubDivisions(result.message);
             setApiData(result.message);
 
             setCircleCode('');
             setOfficeCode(selectedCompanyCode);
             setOfficeName(getCompanies(selectedCompanyCode));
             setCircleName('');
             setSelectedDivision('');
             setSelectedSubDivision('');
             setFilteredSubDivisions([]);
 
             // Populate divisions
             const uniqueDivisions = result.message.reduce((acc, item) => {
               if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                 acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
               }
               return acc;
             }, []);
             setFilteredDivisions(uniqueDivisions);
           } else {
             console.error('Error fetching subDivisions:', result.message);
             setSubDivisions([]);
             setFilteredDivisions([]);
           }
         } else {
           throw new Error(`Request failed with status ${response.status}`);
         }
       } catch (error) {
         console.error('Error fetching subDivisions:', error);
         setSubDivisions([]);
         setFilteredDivisions([]);
       } finally {
         setLoading(false);
       }
     } else if (selectedCircleCode) {
       setCircleCode(selectedCircleCode);
       setOfficeCode(selectedCircleCode);
       const circle = filteredCircles.find(circle => circle.circleCode === selectedCircleCode);
       const circleName = circle?.circleName || '';
       setOfficeName(circleName.concat(' Circle'));
       setCircleName(circleName);
       setSelectedDivision('');
       setSelectedSubDivision('');
       setFilteredSubDivisions([]);
       const uniqueDivisions = subDivisions
         .filter(item => item.circleCode === selectedCircleCode)
         .reduce((acc, item) => {
           if (!acc.some(division => division.divisionCode === item.divisionCode)) {
             acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
           }
           return acc;
         }, []);
       setFilteredDivisions(uniqueDivisions);
     } else {
       // Handle "All Circle" for code != 10
       setCircleCode('');
       setSelectedDivision('');
       setSelectedSubDivision('');
       setFilteredSubDivisions([]);
       if (roleTypeName == 'Technical') {
         if (offCode) {
           setOfficeCode(offCode == 10 ? 15 : offCode);
           let officeName = getName(offCode == 10 ? '15' : offCode.toString(), subDivisions);
           setOfficeName(officeName.concat(' Region'));
           setCircleName('');
           const circles = subDivisions.reduce((acc, curr) => {
             if (!acc.some(item => item.circleCode === curr.circleCode)) {
               acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
             }
             return acc;
           }, []);
           setFilteredCircles(circles);
           const uniqueDivisions = subDivisions.reduce((acc, item) => {
             if (!acc.some(division => division.divisionCode === item.divisionCode)) {
               acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
             }
             return acc;
           }, []);
           setFilteredDivisions(uniqueDivisions);
         }
       } else if (roleTypeName == 'Commercial') {
         if (cfcLevelId == 2) {
           if (offCode) {
             setOfficeCode(offCode.toString().slice(0, 2));
             let offName = cscID;
             setOfficeName(offName);
             setHierarchy(cfcLevelId);
             const uniqueDivisions = subDivisions.reduce((acc, item) => {
               if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                 acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
               }
               return acc;
             }, []);
             setFilteredDivisions(uniqueDivisions);
           }
         } else if (cfcLevelId == 3) {
           if (offCode) {
             setOfficeCode(offCode.toString().slice(0, 3));
             let offName = cscID;
             setOfficeName(offName);
             setHierarchy(cfcLevelId);
             const uniqueDivisions = subDivisions.reduce((acc, item) => {
               if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                 acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
               }
               return acc;
             }, []);
             setFilteredDivisions(uniqueDivisions);
           }
         }
       }
     }
   };
 
   const handleDivisionChange = async (e) => {
     const selectedDivisionCode = parseInt(e.target.value);
     if (code == 10 && selectedDivisionCode && selectedCompanyCode) {
       setLoading(true);
       const myHeaders = new Headers();
       myHeaders.append('Authorization', token);
       const formdata = new FormData();
       formdata.append('companyCode', selectedCompanyCode);
       formdata.append('divisionCode', selectedDivisionCode);
       const requestOptions = {
         method: 'POST',
         headers: myHeaders,
         body: formdata,
         redirect: 'follow',
       };
 
       try {
         const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
         if (response.ok) {
           const result = await response.json();
           if (result.status === '200') {
             setSubDivisions(result.message);
             setApiData(result.message);
 
             setSelectedDivision(selectedDivisionCode);
             setOfficeCode(selectedDivisionCode);
             const division = filteredDivisions.find(division => division.divisionCode === selectedDivisionCode);
             const divisionName = division?.divisionName || '';
             setOfficeName(divisionName.concat(' Division'));
             setSelectedSubDivision('');
             const uniqueSubDivisions = result.message
               .filter(item => item.divisionCode == selectedDivisionCode)
               .reduce((acc, item) => {
                 if (!acc.some(sub => sub.subDivisionCode === item.subDivisionCode)) {
                   acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName, companyCode: item.companyCode });
                 }
                 return acc;
               }, []);
             setFilteredSubDivisions(uniqueSubDivisions);
           } else {
             console.error('Error fetching subDivisions:', result.message);
             setSubDivisions([]);
             setFilteredSubDivisions([]);
           }
         } else {
           throw new Error(`Request failed with status ${response.status}`);
         }
       } catch (error) {
         console.error('Error fetching subDivisions:', error);
         setSubDivisions([]);
         setFilteredSubDivisions([]);
       } finally {
         setLoading(false);
       }
     } else if (selectedDivisionCode) {
       setSelectedDivision(selectedDivisionCode);
       setOfficeCode(selectedDivisionCode);
       const divisionName = filteredDivisions.find(division => division.divisionCode === selectedDivisionCode)?.divisionName || '';
       setOfficeName(divisionName.concat(' Division'));
       setSelectedSubDivision('');
       const uniqueSubDivisions = subDivisions
         .filter(item => item.divisionCode == selectedDivisionCode)
         .reduce((acc, item) => {
           if (!acc.some(sub => sub.subDivisionCode === item.subDivisionCode)) {
             acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName, companyCode: item.companyCode });
           }
           return acc;
         }, []);
       setFilteredSubDivisions(uniqueSubDivisions);
     } else {
       setSelectedDivision('');
       setOfficeCode(circleCode ? circleCode : offCode);
       let officeName = getName(circleCode ? circleCode.toString() : offCode.toString(), subDivisions);
       setOfficeName(officeName.concat(' Circle'));
       setSelectedSubDivision('');
       setFilteredSubDivisions([]);
       const uniqueDivisions = subDivisions
         .filter(item => item.circleCode == (circleCode ? circleCode : offCode))
         .reduce((acc, item) => {
           if (!acc.some(division => division.divisionCode === item.divisionCode)) {
             acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
           }
           return acc;
         }, []);
       setFilteredDivisions(uniqueDivisions);
     }
   };
 
   const handleSubDivisionChange = async (e) => {
     const selectedSubDivisionCode = parseInt(e.target.value);
     if (code == 10 && selectedSubDivisionCode && selectedCompanyCode) {
       setLoading(true);
       const myHeaders = new Headers();
       myHeaders.append('Authorization', token);
       const formdata = new FormData();
       formdata.append('companyCode', selectedCompanyCode);
       formdata.append('subDivisionCode', selectedSubDivisionCode);
       const requestOptions = {
         method: 'POST',
         headers: myHeaders,
         body: formdata,
         redirect: 'follow',
       };
 
       try {
         const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
         if (response.ok) {
           const result = await response.json();
           if (result.status === '200') {
             setSubDivisions(result.message);
             setApiData(result.message);
 
             setSelectedSubDivision(selectedSubDivisionCode);
             setOfficeCode(selectedSubDivisionCode);
             const subDivision = filteredSubDivisions.find(sub => sub.subDivisionCode === selectedSubDivisionCode);
             const subDivisionName = subDivision?.subDivisionName || '';
             setOfficeName(subDivisionName.concat(' Sub Division'));
           } else {
             console.error('Error fetching subDivisions:', result.message);
             setSubDivisions([]);
           }
         } else {
           throw new Error(`Request failed with status ${response.status}`);
         }
       } catch (error) {
         console.error('Error fetching subDivisions:', error);
         setSubDivisions([]);
       } finally {
         setLoading(false);
       }
     } else if (selectedSubDivisionCode) {
       setSelectedSubDivision(selectedSubDivisionCode);
       setOfficeCode(selectedSubDivisionCode);
       const subDivisionName = filteredSubDivisions.find(sub => sub.subDivisionCode === selectedSubDivisionCode)?.subDivisionName || '';
       setOfficeName(subDivisionName.concat(' Sub Division'));
     } else {
       setSelectedSubDivision('');
       let officeName = getName(selectedDivision ? selectedDivision.toString() : offCode.toString(), subDivisions);
       setOfficeName(officeName.concat(' Division'));
       setOfficeCode(selectedDivision ? selectedDivision : offCode);
     }
   };
 
   useEffect(() => {
     if (roleTypeName == 'Technical') { 
       if (offCode) {
         setOfficeCode(offCode == 10 ? 15 : offCode);
         let offName = getName(offCode == 10 ? '15' : offCode.toString(), subDivisions);
         setOfficeName(offName); 
         setHierarchy(offCode.toString().length);
       }
     } else if (roleTypeName == 'Commercial') {
       if (cfcLevelId == 1) {
         if (offCode) {
                             if (offCode == 10) {
            setOfficeCode(15);
            setOfficeName("PITC");
          } else {
            setOfficeCode(offCode);
            let offName = getName(offCode, subDivisions);
            setOfficeName(offName);
          }

          setHierarchy(offCode.length);   
                          }
       } else if (cfcLevelId == 2) {
         if (offCode) {
           setOfficeCode(offCode.toString().slice(0, 2));
           let offName = cscID;
           setOfficeName(offName);
           setHierarchy(cfcLevelId);
         }
       } else if (cfcLevelId == 3) {
         if (offCode) {
           setOfficeCode(offCode.toString().slice(0, 3));
           let offName = cscID;
           setOfficeName(offName);
           setHierarchy(cfcLevelId);
         }
       } else if (cfcLevelId == 4) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 4));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }else if (cfcLevelId == 5) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 5));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }
     }
   }, [offCode, cfcLevelId, roleTypeName, cscID]);
 
   useEffect(() => {
     if (hierarchy) {
       if (hierarchy == 1 || cfcLevelId === 1) {
         console.log('1 wala if');
         let circles = subDivisions.reduce((acc, curr) => {
           if (!acc.some(item => item.circleCode === curr.circleCode)) {
             acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
           }
           return acc;
         }, []);
         setFilteredCircles(circles);
       } else if (hierarchy == 2 || cfcLevelId == 2) {
         console.log('2 wala if');
         let circles = subDivisions.reduce((acc, curr) => {
           if (!acc.some(item => item.circleCode === curr.circleCode)) {
             acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
           }
           return acc;
         }, []);
         setFilteredCircles(circles);
       } else if (hierarchy == 3 || cfcLevelId == 3) {
         console.log('3 wala if');
         setCircleCode(offCode.slice(0, 3));
         console.log(offCode.slice(0, 3), 'djlsahjdhalhdalhlkd');
         const uniqueDivisions = subDivisions
           .filter(item => item.circleCode == offCode.slice(0, 3))
           .reduce((acc, item) => {
             if (!acc.some(division => division.divisionCode === item.divisionCode)) {
               acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
             }
             return acc;
           }, []);
         setFilteredDivisions(uniqueDivisions);
       } else if ((hierarchy == 4 || cfcLevelId == 4) || (hierarchy == 5 || cfcLevelId == 5)) {
         console.log('4 wala if');
         setSelectedDivision(offCode.slice(0, 4));
         const uniqueSubDivisions = subDivisions
           .filter(item => item.divisionCode == offCode.slice(0, 4))
           .reduce((acc, item) => {
             if (!acc.some(sub => sub.subDivisionCode === item.subDivisionCode)) {
               acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName, companyCode: item.companyCode });
             }
             return acc;
           }, []);
         setFilteredSubDivisions(uniqueSubDivisions);
       }
     }
   }, [hierarchy, cfcLevelId, subDivisions]);

    function formatToMillions(value) {
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2, // Fixed to 2 decimal places
            maximumFractionDigits: 2,
        }).format(value / Math.pow(10, 6)); // Convert value to millions
    }

   const currentFilters = {
  officeCode,
  selectedCompanyCode,
  circleCode,
  selectedDivision,
  selectedSubDivision
};

useEffect(() => {
  if (lastAppliedFilters === null) {
    setIsGoDisabled(false);
    return;
  }

  const hasChanged = JSON.stringify(currentFilters) !== JSON.stringify(lastAppliedFilters);
  setIsGoDisabled(!hasChanged);
}, [
  officeCode,
  selectedCompanyCode,
  circleCode,
  selectedDivision,
  selectedSubDivision
]);

const handleGoClick = () => {
  fetchData(officeCode);
  setLastAppliedFilters({ ...currentFilters });
  setIsGoDisabled(true);
};

 const noDataAvailable = () => {
    alert("No data available to export or print.");
  };

    return (
        <>
            <Box className='form-box'>
                <div style={{ display: 'flex', flexDirection: "row" }}>
                    <Box className='application-table' style={{ marginRight: '10px', height: '100%' }}>
                        <h3 style={{ color: '#006ad1', marginBottom: '10px' }}>Daily Batch-Wise Assessment Report</h3>
                        <div className='div-datagrid' style={{ height: '100%' }}>
                            <div className='reports-container' >
                                <div className='filter-fields' style={{ width: '75%', justifyContent: 'flex-start', gap: '15px' }}>

                                   {code == 10 && (
                    <div className="field-container">
                      <Typography className="field-label">Company</Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white" }}
                        value={selectedCompanyCode}
                        onChange={(e) => {
                          handleChangeCompany(e);
                          setData([]);
                        }}
                      >
                        <option value="10">Select Company</option>
                        <option value="11">LESCO</option>
                        <option value="12">GEPCO</option>
                        <option value="13">FESCO</option>
                        <option value="14">IESCO</option>
                        <option value="15">MEPCO</option>
                        <option value="26">PESCO</option>
                        <option value="27">HAZECO</option>
                        <option value="37">HESCO</option>
                        <option value="38">SEPCO</option>
                        <option value="48">QESCO</option>
                        <option value="59">TESCO</option>
                      </select>
                    </div>
                  )}

                  {hierarchy <= 2 && (
                    <div className="field-container">
                      <Typography className="field-label">Circle</Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white" }}
                        value={circleCode || ""}
                        onChange={(e) => {
                          handleCircleChange(e);
                          setData([]);
                        }}
                      >
                        <option value="">All Circle</option>
                        {filteredCircles.map((circle) => (
                          <option
                            key={circle.circleCode}
                            value={circle.circleCode}
                          >
                            {circle.circleName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {hierarchy <= 3 && (
                    <div className="field-container">
                      <Typography className="field-label">Division</Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white" }}
                        value={selectedDivision || ""}
                        onChange={(e) => {
                          handleDivisionChange(e);
                          setData([]);
                        }}
                        disabled={!circleCode}
                      >
                        <option value="">All Division</option>
                        {filteredDivisions.map((division) => (
                          <option
                            key={division.divisionCode}
                            value={division.divisionCode}
                          >
                            {division.divisionName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {hierarchy <= 4 && (
                    <div className="field-container">
                      <Typography className="field-label">
                        Sub-Division
                      </Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white" }}
                        value={selectedSubDivision || ""}
                        onChange={(e) => {
                          handleSubDivisionChange(e);
                          setData([]);
                        }}
                        disabled={!selectedDivision}
                      >
                        <option value="">All Sub-Division</option>
                        {filteredSubDivisions.map((subDivision) => (
                          <option
                            key={subDivision.subDivisionCode}
                            value={subDivision.subDivisionCode}
                          >
                            {subDivision.subDivisionName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                                    
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{ marginTop: '10px' }}
                                       onClick={handleGoClick}
        disabled={isGoDisabled || loading}
                                    >
                                        Go
                                    </Button>
                                    <div className='field-container'>
                                        <Typography className='field-label'></Typography>
                                        <input style={{ display: 'none' }}></input>
                                    </div>
                                    <div className='field-container'>
                                        <Typography className='field-label'> </Typography>
                                        <input style={{ display: 'none' }} type='date' className='date-field' />
                                    </div>

                                    {/* <div className='field-container'>
                                        <button onClick={handleClick} className='primary-button'>
                                            <SearchIcon id="searchBtn" sx={{ color: 'white' }} />
                                        </button>
                                    </div> */}
                                </div>
                                <div className="export-button-container">

                                     <div
                    onClick={() => {
                      if (data.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      DownloadPdf(true);
                    }}
                    style={{ height: "40px", marginLeft: "15px" }}
                  >
                    <img
                      src={pdf}
                      alt="pdf"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (data.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      exportToExcel();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={excel}
                      alt="Excel"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (data.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      printPDF();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={print}
                      alt="print"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                                </div>
                            </div>
                            <div style={{ marginLeft: '4px', display: 'flex', justifyContent: 'center', backgroundColor: 'rgb(213, 229, 255)', color: 'black' }}>
                                <Typography variant="h6" style={{ color: 'black' }}>
                                    Daily Batch-Wise Assessment Report for {officeName} As Of {getCurrentDateFormatted(new Date)} -  Rs. in Million
                                </Typography>
                            </div>

                            <div ref={tableRef} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '30px' }}>
                                <table style={{ borderCollapse: "collapse", width: '45%', backgroundColor: "white" }}
                                >
                                    <thead>
                                        <tr>
                                            <th rowspan="4" style={{
                                                border: "10px solid white",
                                                backgroundColor: '#d5e5fc',
                                                color: 'black',
                                                padding: '10px 10px',
                                                fontSize: '17px',
                                                fontFamily: 'Roboto-Medium'
                                            }}>Batch</th>
                                            <th rowspan="4" style={{
                                                border: "10px solid white",
                                                backgroundColor: '#d5e5fc',
                                                color: 'black',
                                                padding: '10px 10px',
                                                fontSize: '17px',
                                                fontFamily: 'Roboto-Medium'
                                            }}>Opening <br></br>Balance <br></br>(Million)</th>
                                            <th colspan="6" style={{
                                                border: "6px solid white",
                                                backgroundColor: '#d5e5fc',
                                                color: 'black',
                                                padding: '10px 20px',
                                                fontSize: '20px',
                                                fontFamily: 'Roboto-Medium'
                                            }}>Assessment (Rs Millions)</th>
                                        </tr>
                                        <tr >
                                            <th style={{
                                                backgroundColor: '#eeeff0',
                                                color: 'black',
                                                fontSize: '15px',
                                                fontFamily: 'Roboto-Medium',
                                                padding: '5px'
                                            }}>Govt.</th>
                                            <th style={{
                                                border: "2px solid transparent",
                                                backgroundColor: '#eeeff0',
                                                color: 'black',
                                                fontSize: '15px',
                                                fontFamily: 'Roboto-Medium',
                                                padding: '5px'
                                            }}>Private</th>
                                            <th style={{
                                                border: "2px solid transparent",
                                                backgroundColor: '#eeeff0',
                                                color: 'black',
                                                fontSize: '15px',
                                                fontFamily: 'Roboto-Medium',
                                                padding: '5px'
                                            }}>Current</th>
                                            <th style={{
                                                border: "2px solid transparent",
                                                backgroundColor: '#eeeff0',
                                                color: 'black',
                                                fontSize: '15px',
                                                fontFamily: 'Roboto-Medium',
                                                padding: '5px'
                                            }}>Adjustment</th>
                                            <th style={{
                                                border: "2px solid transparent",
                                                backgroundColor: '#eeeff0',
                                                color: 'black',
                                                fontSize: '15px',
                                                fontFamily: 'Roboto-Medium',
                                                padding: '5px'
                                            }}>Detection</th>
                                            <th style={{
                                                border: "2px solid transparent",
                                                backgroundColor: '#eeeff0',
                                                color: 'black',
                                                fontSize: '15px',
                                                fontFamily: 'Roboto-Medium',
                                                padding: '5px'
                                            }}>Net Amount</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            // Display loader in place of table data
                                            <tr>
                                                <td colSpan="15" style={{ textAlign: 'center', padding: '20px' }}>
                                                    <Box display="flex" justifyContent="center" alignItems="center">
                                                        <CircularProgress />
                                                    </Box>
                                                </td>
                                            </tr>
                                        ) : (data.length === 0 ? (
                                            <>
                                                <tr>
                                                    <td colSpan="15" style={{ textAlign: 'center', padding: '10px', fontWeight: 'bold', color: 'red' }}>
                                                        No Data Found
                                                    </td>
                                                </tr>
                                            </>
                                        ) : (
                                            <>
                                                {data.map((item, index) => (
                                                    <tr
                                                        style={{ borderBottom: "1px solid #ccc" }}
                                                        key={index}
                                                    >
                                                        <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>
                                                            {item.BATCH}
                                                        </td>
                                                        <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>{item.OP_BAL ? formatToMillions(item.OP_BAL) : '-'}</td>
                                                        <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>{item.ASSESSMENT_G ? formatToMillions(item.ASSESSMENT_G) : '-'}</td>
                                                        <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>
                                                            {item.ASSESSMENT !== undefined && item.ASSESSMENT_G !== undefined ?
                                                                (formatToMillions(parseFloat(item.ASSESSMENT) - parseFloat(item.ASSESSMENT_G))) : '-'
                                                            }
                                                        </td>
                                                        <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>{item.ASSESSMENT ? formatToMillions(item.ASSESSMENT) : '-'}</td>
                                                        <td style={{ padding: "5px", textAlign: "center", fontSize: "14px", color: "#6293cd", fontFamily: "Roboto-Medium" }}>{item.ADJ_AMOUNT ? formatToMillions(item.ADJ_AMOUNT) : '-'}</td>
                                                        <td style={{ padding: "5px", textAlign: "center", fontSize: "14px", color: "#6293cd", fontFamily: "Roboto-Medium" }}>{item.DET_AMOUNT ? formatToMillions(item.DET_AMOUNT) : '-'}</td>
                                                        <td style={{ padding: "5px", textAlign: "center", fontSize: "14px", color: "#6293cd", fontFamily: "Roboto-Medium" }}>{item.NET ? formatToMillions(item.NET) : '-'}</td>



                                                    </tr>
                                                ))}

                                                <tr style={{ backgroundColor: "#fef5c0", fontWeight: "bold" }}>
                                                    <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>Total</td>
                                                    <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>{formatToMillions(data.reduce((sum, item) => sum + parseFloat(item.OP_BAL || 0), 0))}</td>
                                                    <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>{formatToMillions(data.reduce((sum, item) => sum + parseFloat(item.ASSESSMENT_G || 0), 0))}</td>
                                                    <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>
                                                        {formatToMillions(
                                                            data.reduce((sum, item) => {
                                                                // Parse ASSESSMENT and ASSESSMENT_G to numbers, defaulting to 0 if undefined or null
                                                                const assessment = parseFloat(item.ASSESSMENT || 0);
                                                                const assessmentG = parseFloat(item.ASSESSMENT_G || 0);

                                                                // Add the difference to the running sum, handling NaN cases
                                                                return sum + (isNaN(assessment) || isNaN(assessmentG) ? 0 : assessment - assessmentG);
                                                            }, 0) // Start with an initial sum of 0
                                                        )}
                                                    </td>


                                                    <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>{formatToMillions(data.reduce((sum, item) => sum + parseFloat(item.ASSESSMENT || 0), 0))}</td>
                                                    <td style={{ padding: "5px", textAlign: "center", fontSize: "14px", color: "#6293cd" }}>{formatToMillions(data.reduce((sum, item) => sum + parseFloat(item.ADJ_AMOUNT || 0), 0))}</td>
                                                    <td style={{ padding: "5px", textAlign: "center", fontSize: "14px", color: "#6293cd" }}>{formatToMillions(data.reduce((sum, item) => sum + parseFloat(item.DET_AMOUNT || 0), 0))}</td>
                                                    <td style={{ padding: "5px", textAlign: "center", fontSize: "14px", color: "#6293cd" }}>{formatToMillions(data.reduce((sum, item) => sum + parseFloat(item.NET || 0), 0))}</td>




                                                </tr>
                                            </>
                                        )
                                        )}

                                    </tbody>


                                </table>
                                <div
                                    style={{
                                        width: '2px',
                                        backgroundColor: 'red',
                                        margin: '0 3px', // Adjust spacing if needed
                                    }}
                                ></div>
                                <table style={{ borderCollapse: "collapse", width: '55%', backgroundColor: "white" }}
                                >
                                    <thead>
                                        <tr>
                                            <th colspan="2" style={{
                                                border: "6px solid white",
                                                backgroundColor: '#d5e5fc',
                                                color: 'black',
                                                padding: '10px 20px',
                                                fontSize: '20px',
                                                fontFamily: 'Roboto-Medium'
                                            }}>Adjustment </th>
                                            <th colspan="2" style={{
                                                border: "6px solid white",
                                                backgroundColor: '#d5e5fc',
                                                color: 'black',
                                                padding: '10px 20px',
                                                fontSize: '20px',
                                                fontFamily: 'Roboto-Medium'
                                            }}>Detection </th>
                                            <th colspan="2" style={{
                                                border: "6px solid white",
                                                backgroundColor: '#d5e5fc',
                                                color: 'black',
                                                padding: '10px 20px',
                                                fontSize: '20px',
                                                fontFamily: 'Roboto-Medium'
                                            }}>Import </th>
                                            <th colspan="2" style={{
                                                border: "6px solid white",
                                                backgroundColor: '#d5e5fc',
                                                color: 'black',
                                                padding: '10px 20px',
                                                fontSize: '20px',
                                                fontFamily: 'Roboto-Medium'
                                            }}>Export </th>
                                            <th rowspan="4" style={{
                                                border: "10px solid white",
                                                backgroundColor: '#d5e5fc',
                                                color: 'black',
                                                padding: '10px 10px',
                                                fontSize: '17px',
                                                fontFamily: 'Roboto-Medium'
                                            }}>Net Meter Count</th>
                                            <th rowspan="4" style={{
                                                border: "10px solid white",
                                                backgroundColor: '#d5e5fc',
                                                color: 'black',
                                                padding: '10px 10px',
                                                fontSize: '17px',
                                                fontFamily: 'Roboto-Medium'
                                            }}>Units Billed</th>
                                        </tr>
                                        <tr >
                                            <th style={{
                                                borderLeft: "8px solid white",
                                                backgroundColor: '#eeeff0',
                                                color: 'black',
                                                fontSize: '15px',
                                                fontFamily: 'Roboto-Medium',
                                                padding: '5px'
                                            }}>No.</th>
                                            <th style={{
                                                border: "2px solid transparent",
                                                backgroundColor: '#eeeff0',
                                                color: 'black',
                                                fontSize: '15px',
                                                fontFamily: 'Roboto-Medium',
                                                padding: '5px'
                                            }}>Units(kWh)</th>
                                            <th style={{
                                                borderLeft: "8px solid white",
                                                backgroundColor: '#eeeff0',
                                                color: 'black',
                                                fontSize: '15px',
                                                fontFamily: 'Roboto-Medium',
                                                padding: '5px'
                                            }}>No.</th>
                                            <th style={{
                                                border: "2px solid transparent",
                                                backgroundColor: '#eeeff0',
                                                color: 'black',
                                                fontSize: '15px',
                                                fontFamily: 'Roboto-Medium',
                                                padding: '5px'
                                            }}>Units(kWh)</th>
                                            <th style={{
                                                borderLeft: "8px solid white",
                                                backgroundColor: '#eeeff0',
                                                color: 'black',
                                                fontSize: '15px',
                                                fontFamily: 'Roboto-Medium',
                                                padding: '5px'
                                            }}>Peak</th>
                                            <th style={{
                                                border: "2px solid transparent",
                                                backgroundColor: '#eeeff0',
                                                color: 'black',
                                                fontSize: '15px',
                                                fontFamily: 'Roboto-Medium',
                                                padding: '5px'
                                            }}>Off-Peak</th>
                                            <th style={{
                                                borderLeft: "8px solid white",
                                                backgroundColor: '#eeeff0',
                                                color: 'black',
                                                fontSize: '15px',
                                                fontFamily: 'Roboto-Medium',
                                                padding: '5px'
                                            }}>Peak</th>
                                            <th style={{
                                                border: "2px solid transparent",
                                                backgroundColor: '#eeeff0',
                                                color: 'black',
                                                fontSize: '15px',
                                                fontFamily: 'Roboto-Medium',
                                                padding: '5px'
                                            }}>Off-Peak</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.length > 0 ? (
                                            <>
                                                {data.map((item, index) => (
                                                    <tr
                                                        style={{ borderBottom: "1px solid #ccc" }}
                                                        key={index}
                                                    >
                                                        <td style={{ textAlign: "center", fontSize: "14px" }}>{item.NO_ADJ ? formatNumberWithoutFraction(item.NO_ADJ.toFixed(0)) : '-'}</td>
                                                        <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>{item.ADJ_UNITS ? formatNumberWithoutFraction(item.ADJ_UNITS.toFixed(0)) : '-'}</td>
                                                        <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>{item.NO_DET ? formatNumberWithoutFraction(item.NO_DET.toFixed(0)) : '-'}</td>
                                                        <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>{item.DET_UNITS ? formatNumberWithoutFraction(item.DET_UNITS.toFixed(0)) : '-'}</td>
                                                        <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>{item.KWH_PRV_REM_OFPK ? formatNumberWithoutFraction(item.KWH_PRV_REM_OFPK.toFixed(0)) : '-'}</td>
                                                        <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>{item.KWH_PRV_REM_PK ? formatNumberWithoutFraction(item.KWH_PRV_REM_PK.toFixed(0)) : '-'}</td>
                                                        <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>{item.KWH_REM_OFPK ? formatNumberWithoutFraction(item.KWH_REM_OFPK.toFixed(0)) : '-'}</td>
                                                        <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>{item.KWH_REM_PK ? formatNumberWithoutFraction(item.KWH_REM_PK.toFixed(0)) : '-'}</td>
                                                        <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>{item.NETMTR_CNT ? formatNumberWithoutFraction(item.NETMTR_CNT.toFixed(0)) : '-'}</td>
                                                        <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>{item.UNITS ? formatNumberWithoutFraction(item.UNITS.toFixed(0)) : '-'}</td>
                                                    </tr>
                                                ))}

                                                <tr style={{ backgroundColor: "#fef5c0", fontWeight: "bold" }}>
                                                    <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>{formatNumberWithoutFraction(data.reduce((sum, item) => sum + parseFloat(item.NO_ADJ || 0), 0).toFixed(0))}</td>
                                                    <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>{formatNumberWithoutFraction(data.reduce((sum, item) => sum + parseFloat(item.ADJ_UNITS || 0), 0).toFixed(0))}</td>
                                                    <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>{formatNumberWithoutFraction(data.reduce((sum, item) => sum + parseFloat(item.NO_DET || 0), 0).toFixed(0))}</td>
                                                    <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>{formatNumberWithoutFraction(data.reduce((sum, item) => sum + parseFloat(item.DET_UNITS || 0), 0).toFixed(0))}</td>
                                                    <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>{formatNumberWithoutFraction(data.reduce((sum, item) => sum + parseFloat(item.KWH_PRV_REM_OFPK || 0), 0).toFixed(0))}</td>
                                                    <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>{formatNumberWithoutFraction(data.reduce((sum, item) => sum + parseFloat(item.KWH_PRV_REM_PK || 0), 0).toFixed(0))}</td>
                                                    <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>{formatNumberWithoutFraction(data.reduce((sum, item) => sum + parseFloat(item.KWH_REM_OFPK || 0), 0).toFixed(0))}</td>
                                                    <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>{formatNumberWithoutFraction(data.reduce((sum, item) => sum + parseFloat(item.KWH_REM_PK || 0), 0).toFixed(0))}</td>
                                                    <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>{formatNumberWithoutFraction(data.reduce((sum, item) => sum + parseFloat(item.NETMTR_CNT || 0), 0).toFixed(0))}</td>
                                                    <td style={{ padding: "5px", textAlign: "center", fontSize: "14px" }}>{formatNumberWithoutFraction(data.reduce((sum, item) => sum + parseFloat(item.UNITS || 0), 0).toFixed(0))}</td>

                                                </tr>
                                            </>
                                        ) : (
                                            <tr>
                                                <td colSpan="15" style={{ textAlign: "center", padding: "10px", fontWeight: "bold", color: "red" }}>
                                                    No Data Found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>


                                </table>
                            </div>

                        </div>
                    </Box>
                </div>
            </Box>

        </>
    )
}

export default BatchWiseAssessmentReport